import type { PropertyTypeObject } from '~/core/entities/CRMEnums';
import type { VariantProps } from 'class-variance-authority';

import { cva } from 'class-variance-authority';

export { default as TestimonialCard } from './TestimonialCard.vue';

export const testimonialGiver = cva(
	'absolute bottom-4 right-4 flex w-min  flex-col items-start self-stretch  text-nowrap bg-white p-3',
	{
		variants: {
			heightVariant: {
				onlyName: 'h-[58px] justify-center',
				full: 'h-16 justify-between'
			}
		}
	}
);

export type quotesVariants = VariantProps<typeof testimonialGiver>;

export const testimonialGiverTitle = cva(
	'text-base leading-tight text-primary before:absolute before:right-0 before:top-[-3px] before:h-[24px] before:w-[28px] before:-translate-y-1/2 before:bg-beige lg:text-xl'
);

export type quotesTitleVariants = VariantProps<typeof testimonialGiverTitle>;

export const testimonialGiverSubtitle = cva('text-xs leading-tight', {
	variants: {
		variant: {
			dark: 'text-primary',
			light: 'text-primary-light-4'
		}
	}
});

export type quotesSubtitleVariants = VariantProps<
	typeof testimonialGiverSubtitle
>;

export const content = cva(
	'h-full p-0 text-start text-sm font-normal leading-[175%]',
	{
		variants: {
			variant: {
				dark: 'text-white',
				light: 'text-primary-light-2'
			}
		}
	}
);

export type contentVariants = VariantProps<typeof content>;

export const footer = cva('flex flex-col items-start p-0', {
	variants: {
		variant: {
			dark: 'text-white-dark-4',
			light: 'text-primary-light-1'
		}
	}
});

export type footerVariants = VariantProps<typeof footer>;

export const brokerInfo = cva('h-[58px] w-full p-3', {
	variants: {
		variant: {
			dark: 'bg-primary-light-4',
			light: 'bg-white-dark-1'
		}
	}
});

export type brokerInfoVariants = VariantProps<typeof brokerInfo>;

export const brokerName = cva('text-sm', {
	variants: {
		variant: {
			dark: 'text-white',
			light: 'text-primary'
		}
	}
});

export type brokerNameVariants = VariantProps<typeof brokerName>;

export const companyName = cva('text-xs', {
	variants: {
		variant: {
			dark: 'text-white',
			light: 'text-primary-light-2'
		}
	}
});

export type companyNameVariants = VariantProps<typeof companyName>;

export interface Testimonial {
	image: string;
	propertyType?: PropertyTypeObject | null;
	quote: string;
	author: string;
	brokerName: string;
	brokerSlug?: string | null;
	brokerImage: string;
	companyName: string;
	companyImage: string;
}
